module.exports = __webpack_public_path__ + "static/media/settinggg.03e01b2b.svg";